module.exports = __webpack_public_path__ + "static/media/marker-red-big.9494f500.png";